import Image from 'next/image';
import React from 'react';
import { useBranding } from '../../../hooks/useBranding';

const SAVE_INSTALLATION_IMAGE =
  '/td-home/images/landingpage/hero/save-installation/save-installation-mobile.png';

const DISCOUNT_IMAGE_HUG = '/td-home/images/landingpage/hero/hug/discount-badge-mobile.png';

const ILLUSTRATION_IMAGE =
  '/td-home/images/landingpage/hero/save-installation/hand-drawn-illustration-mobile.png';

interface ImageProps {
  size: { width: number; height: number };
}

const SaveInstallationBadgeMobile: React.FC<ImageProps> = ({ size }) => {
  const branding = useBranding();

  return (
    <div className={'save-installation-mobile position-absolute'}>
      <Image
        className="save-installation-image-mobile mt-3 position-relative"
        width={size.width}
        height={size.height}
        src={branding === 'hug' ? DISCOUNT_IMAGE_HUG : SAVE_INSTALLATION_IMAGE}
        alt={'Jetzt noch Installation sichern!'}
      />
      {branding !== 'hug' && (
        <Image
          className="hand-drawn-illustration-mobile position-relative"
          src={ILLUSTRATION_IMAGE}
          width={43}
          height={47}
          alt={'Handgezeichnete Illustrationen'}
        />
      )}
    </div>
  );
};

export default SaveInstallationBadgeMobile;
